export { default } from "./Bot"



// WEBPACK FOOTER //
// ./src/routes/bot/index.js